import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=07feeaf7"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=07feeaf7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports